// Contact Information Constants
export const CONTACT_INFO = {
  email: 'info@itforsec.com',
  phone: '+995 599-400-135',
  whatsapp: '+995599400135',
  website: 'https://itforsec.com',
  linkedin: 'https://www.linkedin.com/company/itforsec',
  facebook: 'https://www.facebook.com/itforsec',
  instagram: 'https://www.instagram.com/itforsec?igsh=MXZkYTY0cXV4bDdyYw==',
  github: 'https://github.com/ITFORSEC',
  twitter: '',
  youtube: '',
  telegram: '',
  social_visibility: {
    phone: true,
    whatsapp: true,
    linkedin: true,
    facebook: true,
    instagram: true,
    github: true,
    twitter: false,
    youtube: false,
    telegram: false
  }
};

export const COMPANY_INFO = {
  name: 'ITFORSEC',
  address: 'Tbilisi, Georgia',
};
